import Modal from '@/components/Modal';
import Button from '@/components/Button';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { navigate } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

interface ExistingWebIdPopupProps {
  maskedName: string;
  existWebId: string;
  onRequestClose: () => void;
}

const PopupTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #1cabe2;
  text-align: left;
  padding: 32px 32px 0;
  ${breakpoint(`mobile`)} {
    font-size: 18px;
    padding: 24px 24px 0;
  }
`;

const PopupBody = styled.div`
  padding: 24px 32px;
  text-align: center;
  font-size: 16px;
  line-height: 1.8;
  letter-spacing: -0.8px;
  ${breakpoint(`mobile`)} {
    padding: 20px 24px;
    font-size: 14px;
  }
`;

const WebIdDisplay = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #2d2926;
  padding: 12px 0;
  ${breakpoint(`mobile`)} {
    font-size: 16px;
  }
`;

const PopupFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 32px 32px;
  ${breakpoint(`mobile`)} {
    padding: 0 24px 24px;
  }
`;

const FindIdLink = styled.a`
  color: #999;
  font-size: 14px;
  margin-top: 12px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const ExistingWebIdPopup: FC<ExistingWebIdPopupProps> = ({
  maskedName,
  existWebId,
  onRequestClose,
}) => {
  return (
    <Modal
      maxWidth="440px"
      onRequestClose={onRequestClose}
      zIndex="1000"
    >
      <PopupTitle>기존 아이디 안내</PopupTitle>
      <PopupBody>
        <p>{maskedName} 후원자님,</p>
        <p>이미 가입된 아이디가 있습니다.</p>
        <p>기존 아이디로 로그인하여 이용해 주세요.</p>
        <WebIdDisplay>{existWebId}</WebIdDisplay>
      </PopupBody>
      <PopupFooter>
        <Button
          size="sm"
          onClick={() => {
            onRequestClose();
            navigate('/auth/login');
          }}
        >
          기존 아이디로 로그인하기
        </Button>
        <FindIdLink href="/auth/find-id/">
          아이디/비밀번호 찾기
        </FindIdLink>
      </PopupFooter>
    </Modal>
  );
};

export default ExistingWebIdPopup;
